import React, { FC } from 'react';

import { Helmet } from 'react-helmet-async';

import * as O from 'fp-ts/Option';
import { pipe } from 'fp-ts/function';
import { APP_TITLE_PREFIX } from '@core/constants';

interface SeoProps {
  title?: string;
}

const Seo: FC<SeoProps> = ({ title }) => {
  const metaTitle = pipe(
    O.fromNullable(title),
    O.fold(
      () => APP_TITLE_PREFIX,
      t => `${APP_TITLE_PREFIX} - ${t}`,
    ),
  );

  return (
    <Helmet>
      <title>{metaTitle}</title>
    </Helmet>
  );
};

export default Seo;
